import Tag from '~/shared/components/Tag';
import Typography from '~/shared/components/Typography';

import { getOperatorText, getTagVariant } from '../../common/operatorUtils';

import type { RuleCondition as RuleConditionType } from '../hooks/useAutoscaleRulesQuery';

interface RuleConditionProps {
  conditions: RuleConditionType[];
}

export default function RuleCondition({ conditions }: RuleConditionProps) {
  return (
    <div className="flex flex-col gap-2 py-3 h-full overflow-y-auto side-panel-scrollbar pr-1">
      {conditions.map((condition, index) => (
        <div key={index}>
          {index > 0 && (
            <div className="pt-3">
              <Typography variant="caption" fontWeight={500} color="text-gray-700">
                AND
              </Typography>
            </div>
          )}
          <div className="flex flex-col gap-3 pt-3.5">
            <div className="flex items-baseline gap-2">
              <Tag variant={getTagVariant(condition.type)} size="sm" text={condition.condition} />
              <Typography variant="p3-reg" fontWeight={400} color="text-gray-700">
                {getOperatorText(condition.operator, condition.type)}
              </Typography>
            </div>
            <div className="flex flex-wrap gap-[5px] border border-gray-300 rounded-lg p-3">
              {condition.values.map(
                (value: string | Record<string, unknown>, valueIndex: number) => {
                  return <Tag showFullText key={valueIndex} size="sm" text={String(value)} />;
                }
              )}
            </div>
          </div>
        </div>
      ))}

      {conditions.length === 0 && (
        <div className="flex items-center justify-center py-8">
          <Typography variant="p3-reg" color="text-gray-500">
            No conditions match your search
          </Typography>
        </div>
      )}
    </div>
  );
}
